<template>
  <div class="flex flex-col w-full h-full mx-auto p-6 overflow-auto">
    <div class="flex w-full pb-6">
      <div
        v-if="dataLoaded"
        class="w-1/2 h-80 bg-white shadow-lg rounded-lg mx-4 py-4 px-4 overflow-hidden"
      >
        <div>
          <span class="font-semibold text-lg tracking-wider"
            >Levantamientos por tipo</span
          >
        </div>
        <doughnut-lev-chart
          :chartData="principalData"
          :options="doughnutChartOptions"
          :css-classes="'w-1/2 h-64 py-2 mx-auto'"
        ></doughnut-lev-chart>
      </div>

      <div
        v-if="dataLoaded"
        class="w-1/2 h-80 bg-white shadow-lg rounded-lg mx-4 py-4 px-4 overflow-hidden"
      >
        <div>
          <span class="font-semibold text-lg tracking-wider">Levantamientos por estado de revisión</span>
        </div>
        <doughnut-lev-chart
          :chartData="statusData"
          :options="doughnutChartOptions"
          :css-classes="'w-1/2 h-64 py-2 mx-auto'"
        ></doughnut-lev-chart>
      </div>
    </div>

    <!-- <div class="flex w-full pb-6">
      <div
        v-if="dataLoaded"
        class="w-full h-104 bg-white shadow-lg rounded-lg mx-4 py-4 px-4 overflow-hidden"
      >
        <div>
          <span class="font-semibold text-lg tracking-wider"
            >Por categoría secundaria</span
          >
        </div>
        <bar-chart
          :chartData="secundariaData"
          :options="barChartOptions"
          :css-classes="'w-full h-88 py-2 mx-auto'"
        >
        </bar-chart>
      </div>
    </div> -->

    <div class="flex w-full pb-6">
      <div
        class="flex flex-col w-full bg-white shadow-lg rounded-lg mx-4 py-4 px-4 overflow-hidden"
      >
        <div class="w-full pb-2">
          <span class="font-semibold text-lg tracking-wider">Levantamientos por fechas</span>
        </div>
        <div class="flex w-full">
          <div class="w-1/2 px-3 mb-6 md:mb-0">
            <label
              class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
              for="fechaInicio"
              >Fecha inicial</label
            >
            <input
              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
              id="fechaInicio"
              type="date"
              name="fechaInicio"
              v-model="fechaInicio"
              :max="startMaxDate"
              @change="checkStartCalendar"
            />
          </div>

          <div class="w-1/2 px-3 mb-6 md:mb-0">
            <label
              class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
              for="fechaFin"
              >Fecha final</label
            >
            <input
              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
              id="fechaFin"
              type="date"
              name="fechaFin"
              v-model="fechaFin"
              :min="endMinDate"
              :max="endMaxDate"
              @change="checkEndCalendar"
            />
          </div>
        </div>
        <bar-chart
          :chartData="dataByDate"
          :options="barChartOptions"
          :css-classes="'w-full h-88 py-2 mx-auto'"
          v-if="dataByDateLoaded"
        >
        </bar-chart>
        <!--gráfica por municipios -->
        <div class="flex w-full pb-6">
          <div class="flex flex-col w-full mx-4 py-4 px-4">
            <div class="w-full pb-2">
              <span class="font-semibold text-lg tracking-wider"
                >Levantamientos por municipios</span
              >
            </div>

            <bar-chart
              :chartData="dataByMun"
              :options="barChartOptions"
              :css-classes="'w-full h-88 py-2 mx-auto'"
              v-if="dataByMunLoaded"
            >
            </bar-chart>
          </div>
        </div>
        <!-- /gráfica pr municipios -->

      </div>



    </div>





    <div class="flex w-full pb-6">
      <div
        class="flex flex-col w-full bg-white shadow-lg rounded-lg mx-4 py-4 px-4 overflow-hidden"
      >
        <div class="w-full pb-2">
          <span class="font-semibold text-lg tracking-wider">Levantamientos por año</span>
        </div>
        <div class="flex w-full">
          <div class="w-1/5 px-3 mb-6 md:mb-0">
            <label
              class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
              for="selectedYear"
              >Seleccionar año</label
            >
            <div class="relative">
              <select
                v-model="selectedYear"
                name="selectedYear"
                class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                @change="fetchStatisticsByYear"
              >
                <template v-for="(year, index) in years">
                  <option :value="year" :key="index">{{ year }}</option>
                </template>
              </select>
              <div
                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
              >
                <svg
                  class="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <bar-chart
          :chartData="dataByYear"
          :options="barChartOptions"
          :css-classes="'w-full h-88 py-2 mx-auto'"
          v-if="dataByYearLoaded"
        >
        </bar-chart>
      </div>
    </div>

  </div>
</template>

<script lang="ts">
import BarChart from "./BarChart.vue";
import DoughnutLevChart from "./DoughnutLevChart.vue";
import moment from "moment";
import EventBus from "../event-bus";

export default {
  data() {
    return {
      doughnutChartOptions: {
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
      },
      barChartOptions: {
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
              },
            },
          ],
        },
      },
      email: localStorage.getItem("email"),
      user_id: localStorage.getItem("user_id"),
      dataLoaded: false,
      principalData: {},
      statusData: {},
      secundariaData: {},
      fechaInicio: null,
      fechaFin: null,
      dataByDate: {},
      dataByDateLoaded: false,
      startMaxDate: moment(new Date()).format("YYYY-MM-DD"),
      endMinDate: "",
      endMaxDate: moment(new Date()).format("YYYY-MM-DD"),
      selectedPeriod: null,
      selectedFlagUsers: "1",
      quantitiesList: "",
      respData: "",
      rowsActiveUsers: "",
      dataByMun: {},
      dataByMunLoaded: false,      
      // periodsToInterval: [
      //   { id: 0, name: 'Semanas'},
      //   { id: 1, name: 'Meses'}
      // ]
      errors: {
        perInterval: false,
        qtyInterval: false,
      },
      sortingDirectionName: "asc",
      sortingDirectionLastName: "asc",
      sortingDirectionEmail: "asc",
      sortingDirectionQuantity: "asc",
      showSelectInterval: true,
      txtIntervalSelected: "",
      firstYear: null,
      selectedYear: null,
      dataByYear: {},
      dataByYearLoaded: false,
      years: [],
    };
  },
  components: {
    DoughnutLevChart,
    BarChart,
  },
  async mounted() {

    EventBus.$emit("updateNotification", {});
    this.dataLoaded = false;
    this.fetchStatistics();
    this.selectedFlagUsers = "1";


    let endDate = new Date();
    let startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 3);
    this.fechaInicio = moment(startDate).format("YYYY-MM-DD");
    this.fechaFin = moment(endDate).format("YYYY-MM-DD");

    this.selectedYear = new Date().getFullYear();
    this.fetchLevantamientoFirstDate();
    this.fetchStatisticsByMunicipio();
    this.fetchStatisticsByYear();
    this.fetchStatisticsByDate();
  },
  methods: {
    fetchStatistics() {
      this.$root.$emit("showLoading");
      let postData = {
        user_id: this.user_id
      }
      this.axios
        .post("apidev/estadisticas/getUserLevantamientosStatistics",postData, this.config)
        .then((response) => {
          let cat_principal = response.data.cat_principal;
          let principalLabels = [];
          let principalData = [];
          let principalColors = [];

          cat_principal.forEach((category) => {
            principalLabels.push(category.nombre);
            principalData.push(category.total);
            principalColors.push(category.color);
          });

          let dataPrincipalCollection = {
            labels: principalLabels,
            datasets: [
              {
                backgroundColor: principalColors,
                pointBackgroundColor: "white",
                borderWidth: 1,
                pointBorderColor: "#249EBF",
                data: principalData,
              },
            ],
          };

          this.principalData = dataPrincipalCollection;

          let statusArray = response.data.status;
          let statusLabels = [];
          let statusData = [];
          let statusColors = [];

          statusArray.forEach((status) => {
            statusLabels.push(status.status);
            statusData.push(status.total);

            switch (status.status) {
              case "NO REVISADO":
                statusColors.push("#00aedb");
                break;
              case "APROBADO":
                statusColors.push("#00b159");
                break;
              case "EN REVISIÓN":
                statusColors.push("#ffc425");
                break;
              case "RECHAZADO":
                statusColors.push("#d11141");
                break;
              default:
                break;
            }
          });

          let dataStatusCollection = {
            labels: statusLabels,
            datasets: [
              {
                backgroundColor: statusColors,
                pointBackgroundColor: "white",
                borderWidth: 1,
                pointBorderColor: "#249EBF",
                data: statusData,
              },
            ],
          };

          this.statusData = dataStatusCollection;

          let cat_secundaria = response.data.cat_secundaria;

          let datasetData = [];
          let backgroundColors = [];
          this.secundariaData.labels = [];

          cat_secundaria.forEach((category) => {
            this.secundariaData.labels.push(category.nombre);
            datasetData.push(category.total);

            cat_principal.forEach((principal) => {
              if (principal.id_cat_principal === category.id_cat_principal) {
                backgroundColors.push(principal.color);
              }
            });
          });

          this.secundariaData.datasets = [
            {
              label: "Levantamientos",
              backgroundColor: backgroundColors,
              data: datasetData,
            },
          ];

          this.dataLoaded = true;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    checkStartCalendar() {
      this.endMinDate = this.fechaInicio;
      if (this.fechaFin != null) {
        this.fetchStatisticsByDate();
        this.fetchStatisticsByMunicipio();
      }
    },
    checkEndCalendar() {
      this.startMaxDate = this.fechaFin;
      if (this.fechaInicio !== null) {
        this.fetchStatisticsByDate();
        this.fetchStatisticsByMunicipio();
      }
    },
    fetchStatisticsByMunicipio() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/estadisticas/getUserLevantamientosStatisticsByMunicipio",
          {
            fechaInicio: this.fechaInicio,
            fechaFin: this.fechaFin,
            user_id: this.user_id
          },
          this.config
        )
        .then((response) => {
          this.totalByMonth = 0
          let statisticsByMun = response.data.statistics;
          let labelsSet = [];
          let datasetData = [];
          statisticsByMun.forEach((statistic) => {
            labelsSet.push(statistic.municipio);
            datasetData.push(statistic.total);
            this.totalByMonth += parseInt(statistic.total);
          });

          let dataCollection = {
            labels: labelsSet,
            datasets: [
              {
                label: "Levantamientos",
                backgroundColor: "#C5B791",
                data: datasetData,
              },
            ],
          };

          this.dataByMun = dataCollection;

          this.dataByMunLoaded = true;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    fetchStatisticsByDate() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/estadisticas/getUserLevantamientosStatisticsByDate",
          { user_id: this.user_id, fechaInicio: this.fechaInicio, fechaFin: this.fechaFin },
          this.config
        )
        .then((response) => {
          let statisticsByDate = response.data.statistics;
          let labelsSet = [];
          let datasetData = [];
          statisticsByDate.forEach((statistic) => {
            labelsSet.push(moment(statistic.date).format("DD/MM/YYYY"));
            datasetData.push(statistic.total);
          });

          let dataCollection = {
            labels: labelsSet,
            datasets: [
              {
                label: "Levantamientos",
                backgroundColor: "#C5B791",
                data: datasetData,
              },
            ],
          };

          this.dataByDate = dataCollection;

          this.dataByDateLoaded = true;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    changeSelect2() {
      switch (this.selectedPeriod) {
        case "week":
          this.quantitiesList =
            '<option value="1">1</option><option value="2">2</option><option value="3">3</option>';
          break;
        case "month":
          this.quantitiesList =
            "<option value='1'>1</option><option value='2'>2</option><option value='3'>3</option><option value='4'>4</option><option value='5'>5</option><option value='6'>6</option><option value='7'>7</option><option value='8'>8</option><option value='9'>9</option><option value='10'>10</option><option value='11'>11</option><option value='12'>12</option>";
          break;
      }
    },
    validSelAndSearch() {
      var selectQuantity = document.getElementById("qtyInterval").value;
      if (selectQuantity != null || selectQuantity != "") {
        this.searchActiveUsers(1);
      }
    },
    checkDataForm: function (dataForm) {
      // console.log(dataForm.get("perInterval"));

      if (dataForm.get("perInterval") === null) {
        this.errors.perInterval = true;
      } else {
        this.errors.perInterval = false;
      }

      if (this.errors.perInterval) {
        return false;
      }

      return true;
    },
    fetchStatisticsByYear() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/estadisticas/getUserLevantamientosStatisticsByYear",
          { user_id: this.user_id, year: this.selectedYear },
          this.config
        )
        .then((response) => {
          let statisticsByDate = response.data.statistics;
          let labelsSet = [];
          let datasetData = [];
          statisticsByDate.forEach((statistic) => {
            let monthLabel = moment(statistic.date).format("MMMM");
            monthLabel =
              monthLabel.charAt(0).toUpperCase() + monthLabel.slice(1);
            labelsSet.push(monthLabel);
            datasetData.push(statistic.total);
          });

          let dataCollection = {
            labels: labelsSet,
            datasets: [
              {
                label: "Levantamientos",
                backgroundColor: "#C5B791",
                data: datasetData,
              },
            ],
          };

          this.dataByYear = dataCollection;

          this.dataByYearLoaded = true;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    fetchLevantamientoFirstDate() {
      this.$root.$emit("showLoading");
      let postData = {
        user_id:this.user_id
      }
      this.axios
        .post("apidev/estadisticas/getUserLevantamientoFirstDate",postData, this.config)
        .then((response) => {
          let firstDate = new Date(response.data.firstdate[0].date);
          this.firstYear = firstDate.getFullYear();

          let yearDifference = this.selectedYear - this.firstYear;

          for (let index = 0; index <= yearDifference; index++) {
            this.years.push(this.selectedYear - index);
          }

          this.years.sort();

          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
  },
};
</script>

<style scoped>
.overflow-auto::-webkit-scrollbar {
  width: 8px;
}

/* track */
.overflow-auto::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px #f7fafc;
  border-radius: 15px;
}

.overflow-auto::-webkit-scrollbar-thumb {
  background: #b3b3b3;
  border-radius: 15px;
}

.overflow-auto::-webkit-scrollbar-thumb:hover {
  background: #797979;
}
</style>
